if(typeof Mixins === 'undefined'){
    var Mixins = {};
}
